export const shorthands: Record<string, string> = {
  s: '--reporter=silent',
  d: '--loglevel=info',
  dd: '--loglevel=verbose',
  ddd: '--loglevel=silly',
  L: '--latest',
  r: '--recursive',
  silent: '--reporter=silent',
  verbose: '--loglevel=verbose',
  quiet: '--loglevel=warn',
  q: '--loglevel=warn',
  h: '--help',
  H: '--help',
  '?': '--help',
  usage: '--help',
  v: '--version',
  f: '--force',
  local: '--no-global',
  l: '--long',
  p: '--parseable',
  porcelain: '--parseable',
  prod: '--production',
  development: '--dev',
  g: '--global',
  S: '--save',
  D: '--save-dev',
  P: '--save-prod',
  E: '--save-exact',
  O: '--save-optional',
  C: '--dir',
  w: '--workspace-root',
  i: '--interactive',
  F: '--filter',
};
